import './App.svelte.css';
/* src/App.svelte generated by Svelte v3.43.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../_snowpack/pkg/svelte.js';
import Editor from './Editor.svelte.js';

function create_fragment(ctx) {
	let div;
	let editor0;
	let t0;
	let editor1;
	let t1;
	let button0;
	let t3;
	let button1;
	let t5;
	let button2;
	let current;
	let mounted;
	let dispose;
	let editor0_props = { name: "one" };
	editor0 = new Editor({ props: editor0_props });
	/*editor0_binding*/ ctx[4](editor0);
	let editor1_props = { name: "two" };
	editor1 = new Editor({ props: editor1_props });
	/*editor1_binding*/ ctx[5](editor1);

	return {
		c() {
			div = element("div");
			create_component(editor0.$$.fragment);
			t0 = space();
			create_component(editor1.$$.fragment);
			t1 = space();
			button0 = element("button");
			button0.textContent = "->";
			t3 = space();
			button1 = element("button");
			button1.textContent = "<-";
			t5 = space();
			button2 = element("button");
			button2.textContent = "Clear";
			attr(button0, "id", "pushRight");
			attr(button0, "class", "svelte-z5ljah");
			attr(button1, "id", "pushLeft");
			attr(button1, "class", "svelte-z5ljah");
			attr(button2, "id", "reset");
			attr(button2, "class", "svelte-z5ljah");
			attr(div, "id", "app");
			attr(div, "class", "svelte-z5ljah");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(editor0, div, null);
			append(div, t0);
			mount_component(editor1, div, null);
			append(div, t1);
			append(div, button0);
			append(div, t3);
			append(div, button1);
			append(div, t5);
			append(div, button2);
			current = true;

			if (!mounted) {
				dispose = [
					listen(button0, "click", function () {
						if (is_function(/*replicate*/ ctx[3](/*e1*/ ctx[0], /*e2*/ ctx[1]))) /*replicate*/ ctx[3](/*e1*/ ctx[0], /*e2*/ ctx[1]).apply(this, arguments);
					}),
					listen(button1, "click", function () {
						if (is_function(/*replicate*/ ctx[3](/*e2*/ ctx[1], /*e1*/ ctx[0]))) /*replicate*/ ctx[3](/*e2*/ ctx[1], /*e1*/ ctx[0]).apply(this, arguments);
					}),
					listen(button2, "click", /*reset*/ ctx[2])
				];

				mounted = true;
			}
		},
		p(new_ctx, [dirty]) {
			ctx = new_ctx;
			const editor0_changes = {};
			editor0.$set(editor0_changes);
			const editor1_changes = {};
			editor1.$set(editor1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(editor0.$$.fragment, local);
			transition_in(editor1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(editor0.$$.fragment, local);
			transition_out(editor1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			/*editor0_binding*/ ctx[4](null);
			destroy_component(editor0);
			/*editor1_binding*/ ctx[5](null);
			destroy_component(editor1);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let e1, e2;

	const reset = () => {
		e1.reset();
		e2.reset();
	};

	const replicate = (from, to) => () => {
		to.replicateFrom(from.getDoc());
	};

	onMount(() => {
		return () => {
			
		};
	});

	function editor0_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			e1 = $$value;
			$$invalidate(0, e1);
		});
	}

	function editor1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			e2 = $$value;
			$$invalidate(1, e2);
		});
	}

	return [e1, e2, reset, replicate, editor0_binding, editor1_binding];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;